export default __webpack_public_path__ + "static/media/To update.59174c6d.svg";